import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageSquare, X } from 'lucide-react';
import { Button } from './ui/button';

export const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero section (approx 600px)
      if (window.scrollY > 600 && !isDismissed) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed]);

  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleDismiss = () => {
    setIsDismissed(true);
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 100 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
          className="fixed bottom-8 right-8 z-50 floating-cta"
          data-testid="floating-cta"
        >
          <div className="relative">
            {/* Dismiss Button */}
            <button
              onClick={handleDismiss}
              className="absolute -top-2 -right-2 w-6 h-6 bg-white rounded-full shadow-md flex items-center justify-center text-[#64748b] hover:text-[#0a192f] transition-colors z-10"
              data-testid="floating-cta-dismiss"
            >
              <X className="h-3 w-3" />
            </button>

            {/* CTA Button */}
            <Button
              onClick={scrollToContact}
              className="bg-[#D93025] text-white rounded-full px-6 py-4 font-medium hover:bg-[#D93025]/90 transition-all shadow-xl shadow-[#D93025]/30 flex items-center gap-3"
              data-testid="floating-cta-button"
            >
              <MessageSquare className="h-5 w-5" />
              <span className="hidden sm:inline">Request Consultation</span>
              <span className="sm:hidden">Contact</span>
            </Button>

            {/* Urgency Badge */}
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.3, duration: 0.3 }}
              className="absolute -top-3 left-4 bg-white rounded-full px-3 py-1 shadow-lg border border-[#e2e2dc]"
            >
              <span className="text-xs font-medium text-[#0a192f]">
                Free Consultation
              </span>
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
